/* eslint-disable */
class LoaderStore {
    constructor() {
        this.listeners = new Set()
        this.activeLoaders = new Map()
        this.nextId = 0
    }

    subscribe(listener) {
        this.listeners.add(listener)
        return () => this.listeners.delete(listener)
    }

    notify() {
        const messages = Array.from(this.activeLoaders.values())
        this.listeners.forEach((listener) => listener(messages))
    }

    register(message) {
        this.nextId += 1
        const id = this.nextId
        this.activeLoaders.set(id, message || 'Loading...')
        this.notify()
        return id
    }

    update(id, newMessage) {
        if (this.activeLoaders.has(id)) {
            this.activeLoaders.set(id, newMessage || 'Loading...')
            this.notify()
        }
    }

    unregister(id) {
        if (this.activeLoaders.delete(id)) {
            this.notify()
        }
    }
}

export const loaderStore = new LoaderStore()
export default loaderStore
